<script setup lang="ts"></script>

<template>
  <img src="@/assets/bg-title.png" />
</template>

<style scoped></style>
